const styles = (isMobile) => ({
  container: {
    padding: isMobile ? "16px" : "2vh 0vw",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "32px",
  },
  title: {
    fontWeight: 400,
    color: "#0D0D0E",
    marginBottom: "8px",
    fontSize: isMobile ? "28px" : "20px",
    lineHeight: 1.2,
  },
  subtitle: {
    color: "#949daa",
    fontWeight: 500,
  },
  scopesGrid: {
    display: "grid",
    gap: "20px",
    gridTemplateColumns: "repeat(1, 1fr)",
    "@media (min-width: 600px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (min-width: 900px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
  scopeCard: {
    borderRadius: "16px",
    transition: "all 0.3s ease-in-out",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    border: "1px solid #E5E7EB",
    backgroundColor: "#ffffff",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
      borderColor: "#e0e0e0",
    },
  },
  cardContent: {
    flexGrow: 1,
    padding: "2vh 1vw",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "16px",
  },
  scopeName: {
    fontWeight: 600,
    color: "#0D0D0E",
    fontSize: "18px",
    lineHeight: 1.3,
    margin: 0,
    flex: 1,
    marginRight: "12px",
  },
  actionButtons: {
    display: "flex",
    gap: "8px",
  },
  editButton: {
    minWidth: "auto",
    padding: "4px 8px",
    fontSize: "12px",
    color: "#4D6BF6",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "rgba(77, 107, 246, 0.1)",
    },
  },
  deleteButton: {
    minWidth: "auto",
    padding: "4px 8px",
    fontSize: "12px",
    color: "#ef4444",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "rgba(239, 68, 68, 0.1)",
    },
  },
  scopeDescription: {
    color: "#666",
    fontSize: "14px",
    lineHeight: 1.5,
    marginBottom: "16px",
    flex: 1,
  },
  scopeMeta: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "auto",
    paddingTop: "12px",
    borderTop: "1px solid #f5f5f5",
  },
  idChip: {
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
    fontWeight: 600,
    fontSize: "12px",
    borderRadius: "20px",
    padding: "4px 12px",
    height: "24px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "60px 20px",
  },
  emptyState: {
    textAlign: "center",
    padding: "60px 20px",
    color: "#666",
  },
  emptyStateTitle: {
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "12px",
    color: "#333",
  },
  emptyStateSubtitle: {
    fontSize: "16px",
    marginBottom: "24px",
  },
});

export default styles;
